import React from 'react';

/**
 * Modal genérico para confirmación de acciones (reemplazando window.confirm), 
 * sin necesidad de validación de usuario/autorización.
 * @param {object} props
 * @param {boolean} props.show - Si el modal debe estar visible.
 * @param {() => void} props.onClose - Función para cancelar y cerrar el modal.
 * @param {() => void} props.onConfirm - Función a ejecutar al confirmar.
 * @param {string} props.title - Título del modal.
 * @param {string} props.message - Mensaje de confirmación.
 */
const ModalConfirmacion = ({ show, onClose, onConfirm, title, message }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-lg w-full border-t-4 border-yellow-500">
        <div className="p-6">
          <div className="flex items-start">
            <div className="text-yellow-600 mr-4 mt-1">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
              <p className="mt-2 text-sm text-gray-600">{message}</p>
            </div>
          </div>
          
          <div className="mt-6 flex justify-end space-x-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors"
            >
              Cancelar
            </button>
            <button
              onClick={onConfirm}
              className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 shadow-md transition-colors"
            >
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmacion;